export default __webpack_public_path__ + "static/media/aks.0161d663.svg";